import { useQuery } from 'react-query';
import getMenu from 'data/requests/getMenu';
import useBrands from 'data/hooks/useBrands';
import { MenuLocal } from 'model/menu';

const useMenu = (brandId: string) => {
  const { data, isLoading, refetch } = useQuery<MenuLocal>(
    ['menu', brandId],
    () => getMenu(brandId),
    {
      enabled: false,
    },
  );

  const allowAddItem =
    useBrands()
      .brands.find((brand) => brand.id === brandId)
      ?.features.includes('OM_WEB_MENU_ITEM_ADDITION') || false;

  return { data, isLoading, refetch, allowAddItem };
};

export default useMenu;
